<template>
<div class="form-submission-card">
    <submission-title
        :form_name="name"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle
        :form_status="form_submission.form_status"
        :user="form_submission.user"
        hide_status
        @open-signature="openSignature(true)"
    />

    <response-comments :comments="form_submission.comments ?? ''" />

    <div class="form-submission-card-content">
        <list-of-operatives-signatures
            :data="form_submission.signatures"
            :inline_signature="pdf_mode"
            :show_url="show_url"
            is_nested
        />
    </div>
</div>
</template>

<script>
import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures";
import SubmissionTitle from "./SubmissionTitle";
import SubmissionSubtitle from "./SubmissionSubtitle";
import ResponseComments from "./responses/ResponseComments";

export default {
    name: "RAMSSubmission",
    components: {
        ListOfOperativesSignatures,
        SubmissionTitle,
        SubmissionSubtitle,
        ResponseComments,
    },
    props: {
        form_submission: {
            type: Object,
            required: true,
        },
        name: String,
        show_url: String,
        pdf_mode: Boolean,
    },
    methods: {
        openSignature: function (value) {
            this.$refs.signature_modal.openSignature(value);
        }
    }
}
</script>
